import styled, { css } from "styled-components";

const PROMO_HEIGHT = "28px";

const sectionStyles = css`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.header?.fontSize};
  text-transform: ${({ theme }) => theme.header?.textTransform};
`;

export const StyledWrapper = styled.div<{ showPromo: boolean }>`
  position: fixed;
  top: ${({ showPromo }) => (showPromo ? PROMO_HEIGHT : "0")};
  font-family: ${({ theme }) => theme.header?.fontFamily};
  height: 60px;
  width: 100%;
  transition: all 500ms linear;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background-color: ${({ theme }) =>
    theme.header?.shop?.backgroundColor || theme.color.primary};
`;

export const StyledPromo = styled.div`
  background-color: ${({ theme }) => theme.color.accent};
  color: ${({ theme }) => theme.color.primary};
  font-size: 14px;
  line-height: ${PROMO_HEIGHT};
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${PROMO_HEIGHT};
  position: fixed;
  width: 100%;
  top: 0;
`;

export const StyledHeader = styled.div`
  position: fixed;
  z-index: 10000; /* $z-index-modal - 1 */
  font-weight: 500;
`;

export const StyledHeaderLeft = styled.div`
  ${sectionStyles};
  overflow: visible;
`;

export const StyledHeaderRight = styled.div`
  ${sectionStyles};
  justify-content: flex-end;
  min-width: 10%;
`;
